import { useTheme } from "@mui/material/styles";
import { Banknote, Folder, MessageSquare } from "lucide-react";
import { CustomTheme } from "enums/customTheme";
import useAuth from "hooks/useAuth";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";

export default () => {
  function getActive(path: string, pathname: string) {
    return path ? !!matchPath({ path: path, end: false }, pathname) : false;
  }
  const { isSupplierDocumentExpired } = useAuth();
  const supplierId = localStorage.getItem("supplierId");
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();
  const supplier = useSelector((state: any) => state?.supplier);
  const isPaymentModuleEnabled = supplier?.supplier?.isPaymentModuleEnabled;
  const customTheme = supplier?.supplier?.customTheme;
  const getIconColor = (pathPattern: string) => {
    if (getActive(pathPattern, pathname)) return theme.palette.primary.main;
    if (customTheme === CustomTheme.Volotea)
      return theme?.palette?.volotea?.red;
    return theme.palette.text.label;
  };

  const navConfig = [
    {
      show: true,
      items: [
        {
          title: t("Documents"),
          path: `/${supplierId}/documents`,
          icon: <Folder color={getIconColor("/:id/documents")} />,
          locked: isSupplierDocumentExpired,
        },
        {
          title: t("invoice_payments"),
          path: `/${supplierId}/transactions`,
          locked: !isPaymentModuleEnabled || isSupplierDocumentExpired,
          lockedMessage: "",
          icon: <Banknote color={getIconColor("/:id/transactions")} />,
        },
        {
          title: t("queries"),
          path: `/${supplierId}/queries`,
          icon: <MessageSquare color={getIconColor("/:id/queries")} />,
          locked: isSupplierDocumentExpired,
        },
      ],
    },
  ];
  return { navConfig };
};
